<div class="hol-switch-toggle">
  <label (click)="unsetValue()">{{ firstLabel }}</label>
  <label for="checkbox_switch" class="switch">
    <input type="checkbox" name="checkbox_switch" id="checkbox_switch" [checked]="isChecked" />
    <span class="slider round"></span>
  </label>
  <label (click)="setValue()">{{ secondLabel }}</label>
</div>
